/**
 * 统一管理全局挂在插件或实例方法
*/
import Vue from "vue";
import api from '../api/index'; // 引入api接口模块

// 添加Vue实例方法
Vue.prototype.$api = api; 